import { FormField } from '@studio/atomic-ui'
import { googleAnalyticsClientId } from '../env'

export const addAnalyticsFieldToContactForm = (fields: FormField[]) => {
  fields.forEach((field) => {
    if (hasFields(field)) {
      const alreadyExists = field.fields.some((f) => 'name' in f && f.name === googleAnalyticsClientId)

      if (!alreadyExists) {
        field.fields.push({
          type: 'text',
          name: googleAnalyticsClientId,
          label: googleAnalyticsClientId,
          hide: true,
        })
      }
    }
  })

  return fields
}
function hasName(field: FormField): field is FormField & { name: string } {
  return 'name' in field
}

function hasFields(field: FormField): field is FormField & { fields: FormField[] } {
  return Array.isArray((field as any).fields)
}

export const addAnalyticsFieldToForm = (fields: FormField[]) => {
  const alreadyExists = fields.some((f) => hasName(f) && f.name === googleAnalyticsClientId)

  if (!alreadyExists) {
    fields.push({
      type: 'text',
      name: googleAnalyticsClientId,
      label: googleAnalyticsClientId,
      hide: true,
    })
  }
  return fields
}
